import * as React from "react";

function IcProductDuotoneBill(props) {
  const {
    accentColor: accent = "#0194F3",
    color = "#687176",
    width = 24,
    height = 24,
    title,
    titleId,
  } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-id="IcProductDuotoneBill"
      aria-labelledby={titleId}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M14 3H6.5C5.67157 3 5 3.67157 5 4.5V21.5L5.4453 20.8321C5.79185 20.3122 6.37526 20 7 20V20C7.62474 20 8.20815 20.3122 8.5547 20.8321L9 21.5H10L10.4453 20.832C10.7918 20.3122 11.3753 20 12 20V20C12.6247 20 13.2082 20.3122 13.5547 20.832L14 21.5H15L15.4453 20.832C15.7918 20.3122 16.3753 20 17 20V20C17.6247 20 18.2082 20.3122 18.5547 20.8321L19 21.5V8M14 3L19 8M14 3V8H19M8 7H11M8 11H12M8 14H12"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 17H16M15 11H16M15 14H16"
        stroke={accent}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default IcProductDuotoneBill;
